// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bolt-checkbox {
  border-radius: 4px;
  color: rgba(0, 0, 0, .9);
  color: var(--text-primary-color,rgba(0, 0, 0, .9));
  display: inline-flex;
  align-items: center;
}
.bolt-checkbox:focus {
  outline: none;
}
@media (forced-colors: active) {
  .bolt-checkbox:focus {
    border: 2px solid;
    border-color: Highlight;
  }
}
.bolt-checkbox.disabled {
  color: rgba(0, 0, 0, .38);
  color: var(--text-disabled-color,rgba(0, 0, 0, .38));
  cursor: default;
}
@media (forced-colors: active) {
  .bolt-checkbox.disabled {
    forced-color-adjust: none;
    color: graytext;
  }
}
@media (forced-colors: active) {
  .bolt-checkbox.disabled .bolt-checkmark {
    border-color: graytext;
    color: graytext;
  }
}
.bolt-checkbox.disabled.checked .bolt-checkmark {
  background-color: rgba( 200, 200, 200 ,  1 );
  background-color: rgba( var(--palette-neutral-20,200, 200, 200) ,  1 );
}
@media (forced-colors: active) {
  .bolt-checkbox.disabled.checked .bolt-checkmark {
    background-color: transparent;
    border-color: graytext;
  }
}
.bolt-checkbox.disabled:not(.checked) .bolt-checkmark {
  border:  1px solid;
  border-color: rgba( 200, 200, 200 ,  1 );
  border-color: rgba( var(--palette-neutral-20,200, 200, 200) ,  1 );
}
@media (forced-colors: active) {
  .bolt-checkbox.disabled:not(.checked) .bolt-checkmark {
    border-color: graytext;
  }
}
.bolt-checkbox.labelled {
  padding: 2px 4px 2px 5px;
}
.bolt-checkbox:not(.labelled) {
  margin: 2px;
}
.bolt-checkbox.checked .bolt-checkmark {
  border: 1px solid transparent;
  background-color: rgba(0, 120, 212, 1);
  background-color: var(--communication-background,rgba(0, 120, 212, 1));
  color: rgba(255, 255, 255, 1);
  color: var(--text-on-communication-background,rgba(255, 255, 255, 1));
}
@media (forced-colors: active) {
  .bolt-checkbox.checked .bolt-checkmark {
    background-color: transparent;
  }
}
.bolt-checkbox:not(.checked):not(.disabled) .bolt-checkmark {
  border: 1px solid rgba(0, 0, 0, .55);
  border: 1px solid var(--text-secondary-color,rgba(0, 0, 0, .55));
}
@media (forced-colors: active) {
  .bolt-checkbox:not(.checked):not(.disabled) .bolt-checkmark {
    color: windowtext;
    border-color: windowtext;
  }
}
.bolt-checkbox:not(.checked):not(.disabled) .bolt-checkmark > .fabric-icon {
  visibility: hidden;
}

.bolt-checkmark {
  border-radius: 0.25rem;
  color: transparent;
  padding: 1px;
  height: 1rem;
  width: 1rem;
}

.bolt-checkbox-label {
  padding-left: 10px;
  padding-bottom: 1px;
}

.bolt-focus-visible .bolt-checkbox.bolt-focus-treatment:focus {
  animation: ms-focus-shadow-with-border-pulse 4s ease-in-out infinite;
}
@media (forced-colors: active) {
  .bolt-focus-visible .bolt-checkbox.bolt-focus-treatment:focus {
    animation: none;
  }
}
.bolt-focus-visible .bolt-checkbox.bolt-focus-treatment:focus {
  box-shadow: 0 0 0 3px rgba(0, 120, 212, 0.23), 0 0 0 1px rgba(0, 120, 212, 1);
  box-shadow: 0 0 0 3px var(--focus-pulse-max-color,rgba(0, 120, 212, 0.23)), 0 0 0 1px var(--focus-border-color,rgba(0, 120, 212, 1));
}
.bolt-focus-visible .bolt-checkbox.bolt-focus-treatment:focus:not(.checked):not(.labelled) .bolt-checkmark {
  border: 1px solid rgba(0, 120, 212, 1);
  border: 1px solid var(--communication-background,rgba(0, 120, 212, 1));
}
@media (forced-colors: active) {
  .bolt-focus-visible .bolt-checkbox.bolt-focus-treatment:focus:not(.checked):not(.labelled) .bolt-checkmark {
    forced-color-adjust: none;
    border-color: highlight;
  }
}
@media screen and (forced-colors: active) and (prefers-color-scheme: light) {
  .bolt-focus-visible .bolt-checkbox.bolt-focus-treatment:focus:not(.checked):not(.labelled) .bolt-checkmark {
    outline: 1px solid highlight;
    outline-offset: 1px;
  }
}
@media (forced-colors: active) {
  .bolt-focus-visible .bolt-checkbox.bolt-focus-treatment:focus:not(.checked):not(.labelled) .bolt-checkmark {
    color: windowtext;
  }
}
.bolt-focus-visible .bolt-checkbox.bolt-focus-treatment:focus.checked:not(.labelled) .bolt-checkmark {
  border: 1px solid rgba(255, 255, 255, 1);
  border: 1px solid var(--background-color,rgba(255, 255, 255, 1));
}
@media (forced-colors: active) {
  .bolt-focus-visible .bolt-checkbox.bolt-focus-treatment:focus.checked:not(.labelled) .bolt-checkmark {
    forced-color-adjust: none;
    border-color: highlight;
  }
}
@media screen and (forced-colors: active) and (prefers-color-scheme: light) {
  .bolt-focus-visible .bolt-checkbox.bolt-focus-treatment:focus.checked:not(.labelled) .bolt-checkmark {
    outline: 1px solid highlight;
    outline-offset: 1px;
  }
}
@media (forced-colors: active) {
  .bolt-focus-visible .bolt-checkbox.bolt-focus-treatment:focus.checked:not(.labelled) .bolt-checkmark {
    color: windowtext;
  }
}
@media (forced-colors: active) {
  .bolt-focus-visible .bolt-checkbox.bolt-focus-treatment:focus .bolt-checkmark {
    forced-color-adjust: none;
    border-color: highlight;
  }
}
@media screen and (forced-colors: active) and (prefers-color-scheme: light) {
  .bolt-focus-visible .bolt-checkbox.bolt-focus-treatment:focus .bolt-checkmark {
    outline: 1px solid highlight;
    outline-offset: 1px;
  }
}
@media (forced-colors: active) {
  .bolt-focus-visible .bolt-checkbox.bolt-focus-treatment:focus .bolt-checkmark {
    color: windowtext;
  }
}

/*# sourceMappingURL=Checkbox.css.map */
`, "",{"version":3,"sources":["webpack://./../azure-devops-ui/src/Components/Checkbox/Checkbox.scss","webpack://./../azure-devops-ui/src/Core/_platformCommon.scss","webpack://./../azure-devops-ui/bin/Components/Checkbox/Checkbox.css","webpack://./../azure-devops-ui/src/_coreStyles.scss"],"names":[],"mappings":"AACA;EACI,kBAAA;EACA,wBC0JW;EDzJX,kDAAA;EACA,oBAAA;EEAF,mBAAmB;AFEjB;AEAJ;EACE,aAAa;ACuCX;ADrCJ;EACE;IFAU,iBAAA;IEER,uBAAuB;EACzB;AFCE;AECJ;EFCQ,yBAAA;EECN,oDAAoD;EC6BlD,eAAA;AD3BJ;AACA;EACE;IACE,yBAAyB;IACzB,eAAe;ECuBf;ADrBJ;AACA;EACE;IACE,sBAAsB;IACtB,eAAe;EFCX;AECR;AACA;ECcI,4CAAA;EHhBI,sEAAA;AEKR;AACA;EACE;IACE,6BAA6B;IFCzB,sBAAA;EACI;AECZ;ACKI;EHPI,kBAAA;EEKN,wCFFc;EEGd,kEAAkE;AACpE;AFCI;EACI;IECJ,sBAAsB;EFEtB;AEAJ;AACA;EFGI,wBAAA;AEDJ;AACA;EFGQ,WCmH2B;ACpHnC;ACXI;EHSA,6BAAA;EEKF,sCFCU;EEAV,sEAAsE;EACtE,6BAA6B;EFG3B,qEAAA;AEDJ;AACA;ECnBI;IHmBA,6BAAA;EEGF;AACF;AACA;EACE,oCAAoC;EFC9B,gEAAA;AECR;AACA;EACE;IFGF,iBAAA;IACI,wBAAA;EACA;AEDJ;AACA;EFGI,kBAAA;AEDJ;;AFIA;EACI,sBAAA;EACA,kBAAA;EEDF,YAAY;EACZ,YAAY;EFGd,WAAA;AEDA;;AC5CI;EH6CJ,kBAAA;EEGE,mBCjCM;ADkCR;;AFJA;EGxBQ,oEAAA;ADgCR;AFLI;EACI;IEOJ,eAAe;ECxDf;AD0DJ;AACA;EACE,6ECtBM;EDuBN,oIAAoI;AACtI;ACrBI;EHOA,sCAAA;EEiBF,sECvBM;ADwBR;AACA;EACE;ICpEE,yBAAA;IHgDA,uBAAA;EEuBF;AACF;AACA;EFhBI;IACI,4BAAA;IEkBJ,mBAAmB;EC5EnB;AD8EJ;AACA;EACE;IACE,iBAAiB;EACnB;ACzCE;AD2CJ;EACE,wCC3CM;ED4CN,gEC3CM;AD4CR;AACA;ECxFI;IHyDA,yBAAA;IAKQ,uBAAA;EE8BV;AACF;AC7FI;EHkEA;IG7BI,4BAAA;IACA,mBAAA;ED4DN;AACF;AC1DI;EHyBA;IGxBI,iBAAA;ED6DN;AACF;AACA;ECzGI;IHkEA,yBAAA;IAIQ,uBAAA;EEuCV;AACF;AACA;EACE;IACE,4BAA4B;IAC5B,mBAAmB;EACrB;AACF;AACA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA,uCAAuC","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
